module.exports = __webpack_public_path__ + "static/UNB-c08b6a6589b0ec039f148b19bf808f22.eot";